module.exports = __webpack_public_path__ + "static/blomeVorne-16564e2d354a65d043a4291ccd5db22f.jpg";